import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * FaqSchema
 * Genererer usynligt Schema.org FAQPage JSON-LD script for Google Rich Results og GEO/AI crawlere.
 * Rører ikke ved det visuelle layout eller styling overhovedet.
 *
 * @param {Array<{q?: string, question?: string, a?: string, answer?: string}>} items
 */
export default function FaqSchema({ items = [] }) {
  const { lang } = useLanguage();
  if (!items || !items.length) return null;

  const validItems = items
    .map((item) => {
      const question = item?.q || item?.question || '';
      const answerRaw = item?.a || item?.answer || '';
      const cleanAnswer = typeof answerRaw === 'string'
        ? answerRaw.replace(/<[^>]*>/g, '').trim()
        : String(answerRaw || '').trim();

      if (!question || !cleanAnswer) return null;

      return {
        '@type': 'Question',
        'name': question.trim(),
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': cleanAnswer,
        },
      };
    })
    .filter(Boolean);

  if (!validItems.length) return null;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'inLanguage': lang === 'en' ? 'en' : 'da',
    'mainEntity': validItems,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
}
